import React from 'react';
import { QuoteIcon } from 'lucide-react';
export const Testimonials = () => {
  return <section className="mb-10" data-id="element-374">
      <h2 className="text-xl font-bold text-blue-800 mb-6" data-id="element-375">
        Wat deelnemers ervaren tijdens het webinar
      </h2>
      <div className="space-y-6 mb-6" data-id="element-376">
        <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-blue-300" data-id="element-377">
          <div className="flex flex-col md:flex-row mb-3" data-id="element-378">
            <div className="mb-4 md:mb-0 md:mr-4 flex-shrink-0 flex justify-center" data-id="element-379">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1uENzFyeTcPi87ozEBzC5A/Scherm%C2%ADafbeelding_2025-08-15_om_15.51.14.png" alt="Marcel uit Utrecht" className="w-16 h-16 rounded-full object-cover" data-id="element-380" />
            </div>
            <div data-id="element-381">
              <QuoteIcon className="w-6 h-6 text-blue-300 mr-2 flex-shrink-0 float-left" data-id="element-382" />
              <p className="italic" data-id="element-383">
                "Na 20 minuten begreep ik al waarom onze wandelingen altijd
                chaotisch waren. Luna probeerde me de hele tijd te vertellen dat
                ze zich onveilig voelde, maar ik interpreteerde het als
                koppigheid. Het moment dat ik dat doorhad, veranderde alles."
              </p>
              <p className="text-right text-sm font-medium mt-2" data-id="element-384">
                - Marcel uit Utrecht
              </p>
            </div>
          </div>
        </div>
        <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-blue-300" data-id="element-385">
          <div className="flex flex-col md:flex-row mb-3" data-id="element-386">
            <div className="mb-4 md:mb-0 md:mr-4 flex-shrink-0 flex justify-center" data-id="element-387">
              <img src="https://images.unsplash.com/photo-1529429617124-95b109e86bb8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=150&q=80" alt="Thomas uit Antwerpen" className="w-16 h-16 rounded-full object-cover" data-id="element-388" />
            </div>
            <div data-id="element-389">
              <QuoteIcon className="w-6 h-6 text-blue-300 mr-2 flex-shrink-0 float-left" data-id="element-390" />
              <p className="italic" data-id="element-391">
                "Mijn vrouw en ik keken elkaar halverwege het webinar aan.
                'Daarom doet hij dat!' zeiden we tegelijk. Plotseling maakten
                alle rare gewoontes van Rex perfect zin."
              </p>
              <p className="text-right text-sm font-medium mt-2" data-id="element-392">
                - Thomas uit Antwerpen
              </p>
            </div>
          </div>
        </div>
        <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-blue-300" data-id="element-393">
          <div className="flex flex-col md:flex-row mb-3" data-id="element-394">
            <div className="mb-4 md:mb-0 md:mr-4 flex-shrink-0 flex justify-center" data-id="element-395">
              <img src="https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=150&q=80" alt="Sandra uit Amsterdam" className="w-16 h-16 rounded-full object-cover" data-id="element-396" />
            </div>
            <div data-id="element-397">
              <QuoteIcon className="w-6 h-6 text-blue-300 mr-2 flex-shrink-0 float-left" data-id="element-398" />
              <p className="italic" data-id="element-399">
                "Het was emotioneel. Ik realiseerde me dat Buddy mij al maanden
                probeerde iets te vertellen over zijn angst, en ik dacht maar
                dat hij ongehoorzaam was. Ik voelde me schuldig, maar ook
                opgelucht. Eindelijk begreep ik hem."
              </p>
              <p className="text-right text-sm font-medium mt-2" data-id="element-400">
                - Sandra uit Amsterdam
              </p>
            </div>
          </div>
        </div>
      </div>
      <h2 className="text-xl font-bold text-blue-800 mb-4" data-id="element-401">
        De verborgen schade van dominantie
      </h2>
      <p className="mb-6 leading-relaxed" data-id="element-402">
        Wat Marcel niet wist, was dat zijn "alfaleider" benadering Luna
        eigenlijk schade aanbracht:
      </p>
      <ul className="mb-6 list-disc pl-5 space-y-2" data-id="element-403">
        <li data-id="element-404">
          <strong data-id="element-405">Chronische stress</strong> - Domineren zorgt voor constante
          stress bij honden. Constante stress is ongezond.
        </li>
        <li data-id="element-406">
          <strong data-id="element-407">Verhoogde reactiviteit</strong> - Honden raken prikkelbaar en
          reageren daarom sneller op een heftige manier
        </li>
        <li data-id="element-408">
          <strong data-id="element-409">Meer probleemgedrag</strong> - Gestresste honden blaffen meer,
          trekken meer, luisteren minder
        </li>
        <li data-id="element-410">
          <strong data-id="element-411">Gebroken vertrouwen</strong> - Je wordt een bron van
          onzekerheid in plaats van veiligheid
        </li>
      </ul>
      <p className="mb-6 leading-relaxed" data-id="element-412">
        27 recente studies ondersteunen Mech's latere inzichten. Honden zijn
        sociale leerders die bloeien onder duidelijke, liefdevolle communicatie
        en vertrouwen.
      </p>
      <p className="mb-6 leading-relaxed font-semibold text-blue-800" data-id="element-413">
        De waarheid: Honden hebben meer baat bij een begripvol baasje die hun
        taal spreekt, luistert en samenwerkt dan bij een dominante baas.
      </p>
    </section>;
};